module.exports = __webpack_public_path__ + "img/avatar-39.3c5ab365.png";